<template>
    <div class="courier-notice">
        <i class="bi bi-truck"></i>
        <div class="courier-notice-content">
            <slot />
        </div>
    </div>
</template>

<style scoped lang="scss">
    .courier-notice {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 16px 20px;
        border-left: 4px solid $swift-fresh-green;
        border-radius: 8px;
        margin-bottom: 16px;
        background:rgba(0, 0, 0, 0.03);

        .bi-truck {
            color: $success;
            font-size: 1.5rem;
            flex-shrink: 0;
            margin-top: 2px;
        }

        .courier-notice-content {
            flex: 1;
            line-height: 1.9;

            :deep(a) {
                color: $success;
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
</style>
